import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import Sound from '../../../domain/entities/Sound';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexSoundsSuccess: {
      const result = action.payload as PaginatedResult<Sound>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
